import RevFFrame from "../static/images/revf/rev_f_software.webp";
import EcoFrame from "../static/images/cn_amp/plugin_ui.webp";
import DistantFrame from "../static/images/distant_amp/fleshweaver.webp"

export const PRODUCT_NAMES = {
  "ecocide-amplifier-suite": "ToneSuite - Ecocide",
  "distant-amplifier-suite": "ToneSuite - Distant",
  "rev-f-amplifier-suite": "AmpSuite - Rev F",
  "namu-amplifier-suite": "NAM Universal",
  "forte-boost-22": "Forte Boost 22",
  "x-drive-pedal": "X-Drive",
  "resington-shoeless-drive": "Resington Shoeless Drive",
  "cab-suite-412-os-lite": "Cab Suite 412 OS Lite"
}

export const PRODUCT_IMAGES = {
  "rev-f-amplifier-suite": RevFFrame,
  "distant-amplifier-suite": DistantFrame
}